<template>
  <div class="impact-popover" :class="popoverClass">
    <h4 class="impact-popover__header" :class="textClass">
      <FontAwesomeIcon v-if="icon" :icon :class="iconClass" />
      <BittsSvg v-if="iconSvg" :svg="iconSvg" :class="iconClass" />
      {{ title }}
    </h4>
    <div class="flex items-stretch gap-6">
      <div v-if="barClass" class="impact-popover__bar" :class="barClass" />
      <div class="impact-popover__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsIcon, BittsSvg } from '@crossbeam/bitts';

const { title, barClass, iconClass, icon, textClass, popoverClass } =
  defineProps<{
    title: string;
    barClass?: string;
    iconClass: string;
    icon?: BittsIcon;
    iconSvg?: string;
    textClass: string;
    popoverClass?: string;
  }>();
</script>

<style lang="pcss" scoped>
@reference "../css/theme.css";
.impact-popover {
  @apply flex flex-col text-sm max-w-[420px];
}
.impact-popover__bar {
  @apply w-4 min-w-[4px] rounded-bts-lg ml-4;
}
.impact-popover__content {
  @apply flex flex-col text-neutral-text;
}
.impact-popover__header {
  @apply flex items-center gap-4 mb-8 text-sm;
}
</style>
